import { render, staticRenderFns } from "./PricingPlan.vue?vue&type=template&id=04d99dfc&scoped=true"
import script from "./PricingPlan.vue?vue&type=script&lang=js"
export * from "./PricingPlan.vue?vue&type=script&lang=js"
import style0 from "./PricingPlan.vue?vue&type=style&index=0&id=04d99dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d99dfc",
  null
  
)

export default component.exports